import React from 'react';

import Api from 'lib/api';

import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';
import {
  Button,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Alert,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
//import { find } from 'lodash';
import classnames from 'classnames';
import qs from 'qs';

import setupComplete from 'lib/setupComplete';

import { logout } from 'components/app/login/actions';

import Loader from 'components/ui/Loader';
import Icon from 'components/ui/Icon';
//import EntityLogo from 'components/ui/EntityLogo';

import Filters from 'components/app/browse/filters';

import styles from './index.module.css';

const api = Api.getInstance();

class AppNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      resending: false,
      showBrowse: false
    };
  }

  componentDidMount() {
    document.addEventListener('phil:toggle-browse', this.toggleBrowse);
  }

  componentWillUnmount() {
    document.removeEventListener('phil:toggle-browse', this.toggleBrowse);
  }

  logout = () => {
    this.setState({ isOpen: false, showBrowse: false });
    this.props.logout(this.props.history);
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  resendVerificationEmail = () => {
    if (this.state.resending) {
      return;
    }

    this.setState({
      resending: true
    });

    api.get('users/resend-welcome-email').then(
      response => {
        toast.success(`Check your email at ${this.props.login.user.username}`);
        this.setState({
          resending: false
        });
      },
      error => {
        toast.error(error.message);
        this.setState({
          resending: false
        });
      }
    );
  };

  onBrowse = () => {
    return document.location.pathname.indexOf('/browse') === 0;
  };

  doFiltering = query => {
    if (!query) {
      return;
    }

    this.setState(
      {
        showBrowse: false
      },
      () => {
        this.props.history.push('/browse?' + qs.stringify(query));
      }
    );
  };

  toggleBrowse = () => {
    if (
      this.onBrowse() &&
      document.location.pathname.indexOf('/browse/') === -1
    ) {
      return;
    }

    this.setState({
      showBrowse: !this.state.showBrowse
    });
  };

  hideBrowse = () => {
    this.setState({
      showBrowse: false
    });
  };

  render() {
    if (!this.props.login) {
      return null;
    }

    if (!this.props.login.authenticated) {
      return null;
    }

    if (!this.props.login.user) {
      return null;
    }

    const link = (path, label) => {
      return (
        <NavLink
          active={
            !this.state.showBrowse &&
            document.location.pathname.indexOf(path) === 0
          }
          tag={Link}
          to={path}
          onClick={() => this.setState({ isOpen: false, showBrowse: false })}
        >
          <span>{label}</span>
        </NavLink>
      );
    };

    let nav = null;
    //let logo = null;
    let isCorp = false;

    if (setupComplete(this.props.login.user)) {
      if (this.props.login.user.type === 'nonprofit') {
        nav = (
          <Nav navbar>
            <NavItem>{link('/dashboard', 'Dashboard')}</NavItem>
            <NavItem>{link('/sponsorships', 'Sponsorships')}</NavItem>
          </Nav>
        );
        //logo = find(this.props.login.user.nonprofit.meta_datas, {name: 'logo'});
      } else if (this.props.login.user.type === 'admin') {
        nav = (
          <Nav navbar>
            <NavItem>{link('/dashboard', 'Dashboard')}</NavItem>
            <NavItem className={styles['separator']} />
            <NavItem>{link('/sponsorships', 'Sponsorships')}</NavItem>
            <NavItem className={styles['separator']} />
            <NavItem>{link('/nonprofits', 'Nonprofits')}</NavItem>
            <NavItem>{link('/corporations', 'Companies')}</NavItem>
            <NavItem className={styles['separator']} />
            <NavItem>{link('/users', 'Users')}</NavItem>
          </Nav>
        );
      } else {
        isCorp = true;

        nav = (
          <Nav navbar>
            <NavItem>{link('/dashboard', 'Dashboard')}</NavItem>
            <NavItem>
              <NavLink
                onClick={this.toggleBrowse}
                active={this.state.showBrowse || this.onBrowse()}
              >
                Search
              </NavLink>
            </NavItem>
            {/* <NavItem>{link('/browse', 'Browse')}</NavItem> */}
            <NavItem>{link('/sponsorships', 'Sponsorships')}</NavItem>
          </Nav>
        );

        //logo = find(this.props.login.user.corporation.meta_datas, {name: 'logo'});
      }
    }

    let navbar = (
      <Navbar
        color="dark"
        expand="md"
        dark
        fixed="top"
        className={styles['navbar-custom']}
      >
        <NavbarBrand
          tag={Link}
          to="/dashboard"
          className={styles['logo']}
          onClick={() => this.setState({ isOpen: false, showBrowse: false })}
          title="Return to dashboard"
        >
          <img src="/img/logo.svg" alt="Philanthropic.ly" />
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          {nav}
          <Nav navbar className={classnames('ml-auto', styles['account-nav'])}>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                {this.props.login.user.name}
              </DropdownToggle>
              <DropdownMenu right>
                {setupComplete(this.props.login.user) && (
                  <React.Fragment>
                    <DropdownItem
                      onClick={() => {
                        this.hideBrowse();
                        this.props.history.push('/account');
                      }}
                    >
                      Account Settings{' '}
                      <Icon icon="cog" size="xs" className="ml-2" fixedWidth />
                    </DropdownItem>
                    {this.props.login.user.type === 'admin' && (
                      <React.Fragment>
                        <DropdownItem divider />
                        <DropdownItem
                          onClick={() => {
                            this.setState({ isOpen: false, showBrowse: false });
                            this.props.history.push('/settings');
                          }}
                        >
                          App Settings{' '}
                          <Icon
                            icon="wrench"
                            size="xs"
                            className="ml-2"
                            fixedWidth
                          />
                        </DropdownItem>
                        <DropdownItem divider />
                      </React.Fragment>
                    )}
                    {(this.props.login.user.type === 'nonprofit' ||
                      this.props.login.user.type === 'corporation-admin') && (
                      <React.Fragment>
                        <DropdownItem divider />
                        <DropdownItem
                          onClick={() => {
                            this.setState({ isOpen: false, showBrowse: false });
                            this.props.history.push('/profile');
                          }}
                        >
                          {this.props.login.user.type === 'nonprofit'
                            ? 'Nonprofit'
                            : 'Company'}{' '}
                          Profile{' '}
                          <Icon
                            icon="smile"
                            size="xs"
                            className="ml-2"
                            fixedWidth
                          />
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => {
                            this.setState({ isOpen: false, showBrowse: false });
                            this.props.history.push('/users');
                          }}
                        >
                          Manage Users{' '}
                          <Icon
                            icon="users"
                            size="xs"
                            className="ml-2"
                            fixedWidth
                          />
                        </DropdownItem>
                        <DropdownItem divider />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
                <DropdownItem onClick={this.logout}>
                  Logout{' '}
                  <Icon icon="sign-out" size="xs" className="ml-2" fixedWidth />
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    );

    if (!this.props.login.user.verified) {
      navbar = (
        <React.Fragment>
          {navbar}
          <Alert color="warning" className={styles['verify-banner']}>
            <small>
              Please verify your email address. If you haven't received it yet,
              we can{' '}
              <a
                disabled={this.state.resending}
                onClick={this.resendVerificationEmail}
              >
                resend the verification email.
              </a>
              {this.state.resending && ' ' && <Loader />}
            </small>
          </Alert>
        </React.Fragment>
      );
    }

    const browseClasses = {};

    if (this.state.showBrowse) {
      browseClasses[styles['show-filters']] = true;
    }

    navbar = (
      <React.Fragment>
        {navbar}
        {isCorp && (
          <div
            className={classnames(
              styles['navbar-filters'],
              browseClasses,
              'navbar-filter-container'
            )}
          >
            <h4>
              Search For Sponsorship Opportunities
              <Button
                className="close"
                color="link"
                onClick={() => this.setState({ showBrowse: false })}
              >
                &times;
              </Button>
            </h4>
            <hr />
            <Filters
              onFilter={this.doFiltering}
              loading={false}
              categories={this.props.categories}
              filterForm={this.props.filterForm}
              expandAll={true}
            />
          </div>
        )}
      </React.Fragment>
    );

    return navbar;
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
    categories: state.browse.categories,
    filterForm: state.form.filterForm
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: history => {
      dispatch(logout(history));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AppNavbar)
);



// WEBPACK FOOTER //
// ./src/components/app/shared/AppNavbar/index.js